// Mock data for Lone Star Republic Consulting website
// This will be replaced with real backend integration later

export const contactSubmissions = [];

export const submitContactForm = (formData) => {
  // Mock submission - stores in memory only
  const submission = {
    id: Date.now(),
    ...formData,
    timestamp: new Date().toISOString(),
    status: 'pending'
  };
  contactSubmissions.push(submission);
  
  // Simulate email notification (mock)
  console.log('Mock email sent to hello@lonestarrepublicco.com:', formData);
  
  return { success: true, message: 'We received your message. We\'ll respond personally within one business day.' };
};

export const images = {
  hero: {
    home: 'https://customer-assets.emergentagent.com/job_repo-to-web-7/artifacts/8dc60uij_Home_Independent_Consulting_from.jpeg',
    consultation: 'https://customer-assets.emergentagent.com/job_repo-to-web-7/artifacts/5zgbrmci_Home_Why_Clients_Work.jpeg',
    professional: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=1600&q=80',
    ourApproach: 'https://customer-assets.emergentagent.com/job_repo-to-web-7/artifacts/8xpem2v9_Home_Our_Approach_.jpg'
  },
  services: {
    advisory: 'https://customer-assets.emergentagent.com/job_repo-to-web-7/artifacts/rbxsvgj3_Services_1_Cybersecurity_Readiness.jpeg',
    collaboration: 'https://customer-assets.emergentagent.com/job_repo-to-web-7/artifacts/pqdlfhfn_Services_3_Ongoing_Advisory.jpeg',
    training: 'https://customer-assets.emergentagent.com/job_repo-to-web-7/artifacts/0c89r0lw_Services_2_AI_Guidance.jpeg'
  },
  business: {
    restaurant: 'https://customer-assets.emergentagent.com/job_repo-to-web-7/artifacts/z66vwt3m_For_Small_Business_2_Guidance_For_Rest.jpeg',
    smallBusiness: 'https://customer-assets.emergentagent.com/job_repo-to-web-7/artifacts/ag8op7hp_For_Small_Business_1_top_image.jpeg',
    operations: 'https://images.unsplash.com/photo-1687422808248-f807f4ea2a2e?w=800&q=80'
  },
  publicSector: {
    library: 'https://customer-assets.emergentagent.com/job_repo-to-web-7/artifacts/z3vfv0eh_For_Public_Entities_1_top_image.jpeg',
    community: 'https://customer-assets.emergentagent.com/job_repo-to-web-7/artifacts/l0okzgri_For_Public_Entities_2_TAC_202.jpeg',
    unity: 'https://images.pexels.com/photos/7888976/pexels-photo-7888976.jpeg?w=800&q=80'
  }
};

export const testimonials = [
  {
    id: 1,
    text: "They explained everything in plain English. No pressure, just clear guidance.",
    author: "Local Business Owner",
    location: "Abilene, TX"
  },
  {
    id: 2,
    text: "Finally, someone who understands what small organizations actually need.",
    author: "Nonprofit Director",
    location: "West Texas"
  }
];
